import Model from './Model'
import {OperativePlanningBooking} from "./index";
import {parseMoment} from "../utils";

export default class OperativePlanning extends Model {
    getRelationships() {
        return {
            bookings: OperativePlanningBooking,
            present: OperativePlanningBooking,
            absent: OperativePlanningBooking,
        }
    }

    key() {
        return this.date
    }

    getPresentAbsentArray() {
        if (this.present_count > 0 || this.absent_count > 0) {
            return [`${this.present_count} Present`, `${this.absent_count} Absent`]
        }
        return []
    }

    static async all(packageId = null, filter = 'all') {
        const config = {params: {filter}}
        const {data} = await Http.get(route('api.v1.packages.operative-planning.index', packageId), config)
        return this.make(data)
    }

    static async create(attributes) {
        const url = route('api.v1.packages.operative-planning.store', attributes.package_id)
        const {data} = await Http.post(url, attributes)
        return this.make(data)
    }

    async update(attributes = {}) {
        const url = route('api.v1.packages.operative-planning.store', attributes.package_id)
        const {data} = await Http.post(url, attributes)
        return this.fill(data)
    }

    canConfirmPresence() {
        const parsedDate = parseMoment(this.date, 'YYYY-MM-DD', false)
        return parsedDate.isBefore() || parsedDate.isSame()
    }

    async delete() {
        await Http.delete(route('api.v1.packages.operative-planning.delete', {
            package: this.package_id,
            date: this.key()
        }))
    }
}
